import "%modules%/header/header";
import "%modules%/animation/animation";
import "%modules%/preloader/preloader";
import "%modules%/first/first";
import "%modules%/footer/footer";